import { Component, Input } from "@angular/core";
import { ThemeService } from "src/app/main/services/theme/theme.service";

@Component({
  selector: "app-public-header",
  templateUrl: "./public-header.component.html",
  styleUrls: ["./public-header.component.scss"],
  standalone: false,
})
export class PublicHeaderComponent {
  @Input() showCFEPLogo: boolean = true;
  @Input() cobrandedLogo: string | undefined;

  constructor(public themeService: ThemeService) {}
}
